/**
 * Health score orbit graph — ported from health-score.html for connection-successful-modal step 5.
 * window.csHealthGraphStep5.start(stepEl, { onComplete })
 * window.csHealthGraphStep5.stop()
 */
(function () {
  /* Labels + sample values (reference health-score 2.html); cards show names only. */
  var METRICS = [
    { name: 'RHR', val: '54 bpm' },
    { name: 'VO2 Max', val: '48' },
    { name: 'HRV', val: '52 ms' },
    { name: 'Deep Sleep', val: '1h 42m' },
    { name: 'Recovery', val: '94%' },
    { name: 'Disruptions', val: 'Low' },
    { name: 'REM Sleep', val: '1h 55m' },
    { name: 'Total Sleep', val: '7h 38m' },
    { name: 'Light Sleep', val: '3h 58m' }
  ];

  function isLightSleepMetric(i) {
    return METRICS[i] && METRICS[i].name === 'Light Sleep';
  }

  var FLOAT_PARAMS = [
    { dur: '5.8s', delay: '0s' },
    { dur: '6.4s', delay: '0.18s' },
    { dur: '5.5s', delay: '0.36s' },
    { dur: '6.1s', delay: '0.07s' },
    { dur: '5.9s', delay: '0.52s' },
    { dur: '6.6s', delay: '0.29s' },
    { dur: '5.7s', delay: '0.44s' },
    { dur: '6.2s', delay: '0.11s' },
    { dur: '5.6s', delay: '0.61s' }
  ];

  var TARGET = 87;
  var ACCENT = '#34c759';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var METRIC_PULL_MS = 1120;
  var ARC_ANIM_DURATION_MS = 1950;

  var ARC_R = 52;
  var ARC_C = 2 * Math.PI * ARC_R;
  var ARC_CX = 64;
  var ARC_CY = 64;

  var stepRoot = null;
  var onCompleteCb = null;
  var seqGen = 0;
  var resizeObserver = null;
  var resizeFallbackTimer = null;

  var els = {};

  var connectorSignalsRetired = false;
  var hiddenFlowSvg = null;
  var ambientPathRefs = [];
  var flowParticles = [];
  var MAX_FLOW = 34;
  var ambientRaf = null;
  var lastAmbientTime = 0;
  var ambientRunning = false;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function $(sel) {
    return stepRoot ? stepRoot.querySelector(sel) : null;
  }

  function bindElements() {
    els.orbit = $('#cs-hs-orbit');
    els.composition = $('#cs-hs-composition');
    els.progArc = $('#cs-hs-progArc');
    els.glowArc = $('#cs-hs-glowArc');
    els.ambientArc = $('#cs-hs-ambientArc');
    els.arcDot = $('#cs-hs-arcDot');
    els.scoreNum = $('#cs-hs-scoreNum');
    els.scoreWrap = $('#cs-hs-scoreWrap');
    els.scoreBadge = $('#cs-hs-scoreBadge');
    els.scoreEyebrow = $('#cs-hs-scoreEyebrow');
    els.signalPaths = $('#cs-hs-signalPaths');
    els.signalsLayerSvg = $('#cs-hs-signalsLayerSvg');
    els.accentParticlesEl = $('#cs-hs-accentParticles');
    els.ambientCanvas = $('#cs-hs-ambientCanvas');
    els.orbitRing = $('#cs-hs-orbitRing');
    els.ambientCtx = els.ambientCanvas ? els.ambientCanvas.getContext('2d') : null;
  }

  function registerCssProps() {
    try {
      if (window.CSS && CSS.registerProperty) {
        CSS.registerProperty({
          name: '--orbit-r',
          syntax: '<length>',
          inherits: true,
          initialValue: '99px'
        });
        CSS.registerProperty({
          name: '--pull',
          syntax: '<number>',
          inherits: false,
          initialValue: '0'
        });
      }
    } catch (e) {}
  }

  function initArc(el, opacity) {
    if (!el) return;
    el.setAttribute('stroke-dasharray', String(ARC_C));
    el.setAttribute('stroke-dashoffset', String(ARC_C));
    el.setAttribute('stroke', ACCENT);
    if (opacity !== undefined) el.setAttribute('opacity', String(opacity));
  }

  function buildMetricCards() {
    if (!els.orbit) return;
    els.orbit.innerHTML = '';
    METRICS.forEach(function (m, i) {
      var card = document.createElement('article');
      card.className = 'cs-health-metric-card';
      card.setAttribute('data-i', String(i));
      card.setAttribute('aria-label', m.name + ', ' + m.val);
      var fp = FLOAT_PARAMS[i] || { dur: '6s', delay: '0s' };
      card.style.setProperty('--float-dur', fp.dur);
      card.style.setProperty('--float-delay', fp.delay);
      card.innerHTML =
        '<div class="cs-health-metric-inner">' +
        '<span class="cs-health-metric-name">' +
        m.name +
        '</span>' +
        '</div>';
      els.orbit.appendChild(card);
    });
  }

  function ensureHiddenFlowSvg() {
    if (!els.composition) return;
    if (hiddenFlowSvg && hiddenFlowSvg.parentNode) return;
    var existing = els.composition.querySelector('svg[data-cs-hs-flow-paths]');
    if (existing) {
      hiddenFlowSvg = existing;
      return;
    }
    hiddenFlowSvg = document.createElementNS(SVG_NS, 'svg');
    hiddenFlowSvg.setAttribute('data-cs-hs-flow-paths', '1');
    hiddenFlowSvg.setAttribute('aria-hidden', 'true');
    hiddenFlowSvg.style.cssText =
      'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none;visibility:hidden';
    els.composition.appendChild(hiddenFlowSvg);
  }

  function getPositions() {
    var rect = els.composition.getBoundingClientRect();
    var cards = els.orbit.querySelectorAll('.cs-health-metric-card');
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      var cr = cards[i].getBoundingClientRect();
      out.push({
        x: cr.left + cr.width / 2 - rect.left,
        y: cr.top + cr.height / 2 - rect.top
      });
    }
    return {
      rect: rect,
      center: { x: rect.width / 2, y: rect.height / 2 },
      anchors: out
    };
  }

  function rebuildAmbientPaths() {
    if (!hiddenFlowSvg || !els.orbit) return;
    hiddenFlowSvg.innerHTML = '';
    ambientPathRefs = [];
    var layout = getPositions();
    var rw = layout.rect.width;
    var rh = layout.rect.height;
    if (rw < 8 || rh < 8) return;
    hiddenFlowSvg.setAttribute('viewBox', '0 0 ' + rw + ' ' + rh);
    layout.anchors.forEach(function (a, i) {
      if (isLightSleepMetric(i)) return;
      var tcx = layout.center.x;
      var tcy = layout.center.y;
      var dx = tcx - a.x;
      var dy = tcy - a.y;
      var mx = a.x + dx * 0.38;
      var my = a.y + dy * 0.38 + ((i % 3) - 1) * rw * 0.012;
      var d = 'M ' + a.x + ' ' + a.y + ' Q ' + mx + ' ' + my + ' ' + tcx + ' ' + tcy;
      var p = document.createElementNS(SVG_NS, 'path');
      p.setAttribute('d', d);
      hiddenFlowSvg.appendChild(p);
      ambientPathRefs.push(p);
    });
  }

  function resizeAmbientCanvas() {
    if (!els.ambientCanvas || !els.ambientCtx || !els.composition) return;
    var rect = els.composition.getBoundingClientRect();
    var w = rect.width;
    var h = rect.height;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    els.ambientCanvas.width = Math.max(1, Math.floor(w * dpr));
    els.ambientCanvas.height = Math.max(1, Math.floor(h * dpr));
    els.ambientCanvas.style.width = w + 'px';
    els.ambientCanvas.style.height = h + 'px';
    els.ambientCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
    rebuildAmbientPaths();
    updateOrbitRing();
  }

  function updateOrbitRing() {
    if (!els.composition || !els.orbitRing) return;
    var rect = els.composition.getBoundingClientRect();
    if (rect.width < 8) return;
    var cs = getComputedStyle(els.composition);
    var orbitStr = cs.getPropertyValue('--orbit-r').trim();
    var rPx = parseFloat(orbitStr);
    if (!isFinite(rPx) || rPx <= 0) rPx = Math.min(0.357 * rect.width, 168);
    var scale = 400 / rect.width;
    els.orbitRing.setAttribute('r', String((rPx * scale).toFixed(1)));
  }

  function syncOrbitRadius() {
    if (!els.composition) return;
    var rect = els.composition.getBoundingClientRect();
    var w = rect.width;
    var h = rect.height;
    if (w < 8 || h < 8) return;
    var half = Math.min(w, h) / 2;
    var orbitPx = Math.min(168, w * 0.357);
    var maxByFrame = Math.max(50, half - 36);
    orbitPx = Math.min(orbitPx, maxByFrame);
    els.composition.style.setProperty('--orbit-r', orbitPx.toFixed(4) + 'px');
    updateOrbitRing();
  }

  function animateMetricPull(card) {
    if (!card) return;
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        card.style.setProperty('--pull', '1');
        return;
      }
    } catch (e) {}
    card.style.setProperty('--pull', '0');
    var t0 = performance.now();
    function frame(now) {
      var u = Math.min(1, (now - t0) / METRIC_PULL_MS);
      card.style.setProperty('--pull', String(easeOutCubic(u)));
      if (u < 1) requestAnimationFrame(frame);
      else card.style.setProperty('--pull', '1');
    }
    requestAnimationFrame(frame);
  }

  function spawnFlowParticle() {
    if (!ambientPathRefs.length || flowParticles.length >= MAX_FLOW) return;
    var idx = Math.floor(Math.random() * ambientPathRefs.length);
    var path = ambientPathRefs[idx];
    var len = path.getTotalLength();
    if (len < 4) return;
    var isGreen = false;
    var highlight = !isGreen && Math.random() < 0.1;
    var baseAlpha = isGreen
      ? 0.09 + Math.random() * 0.13
      : highlight
        ? 0.1 + Math.random() * 0.11
        : 0.024 + Math.random() * 0.046;
    var r = isGreen
      ? 1.1 + Math.random() * 0.65
      : highlight
        ? 1.35 + Math.random() * 0.65
        : 0.45 + Math.random() * 0.65;
    flowParticles.push({
      path: path,
      len: len,
      s: Math.random() * len * 0.05 + len * 0.02,
      speed: 0.017 + Math.random() * 0.038,
      isGreen: isGreen,
      highlight: highlight,
      baseAlpha: baseAlpha,
      r: r,
      trail: []
    });
  }

  function ambientTick(now) {
    if (!els.ambientCtx || !els.ambientCanvas || !ambientRunning || !els.composition) return;
    var dt = lastAmbientTime ? Math.min(44, now - lastAmbientTime) : 16.67;
    lastAmbientTime = now;

    var rect = els.composition.getBoundingClientRect();
    els.ambientCtx.clearRect(0, 0, rect.width, rect.height);

    if (Math.random() < 0.022 && flowParticles.length < MAX_FLOW) spawnFlowParticle();

    for (var i = flowParticles.length - 1; i >= 0; i--) {
      var p = flowParticles[i];
      p.s += p.speed * (dt / 16.67);
      if (p.s >= p.len * 0.97) {
        flowParticles.splice(i, 1);
        continue;
      }

      var pt = p.path.getPointAtLength(p.s);
      var prog = p.s / p.len;
      var fade = prog > 0.7 ? 1 - (prog - 0.7) / 0.3 : 1;

      p.trail.push({ x: pt.x, y: pt.y });
      if (p.trail.length > 13) p.trail.shift();

      for (var j = 1; j < p.trail.length; j++) {
        var t0 = p.trail[j - 1];
        var t1 = p.trail[j];
        var ta = j / p.trail.length;
        var trailA = (0.009 + ta * 0.026) * (p.isGreen ? 1.35 : p.highlight ? 1.55 : 1) * fade;
        els.ambientCtx.beginPath();
        els.ambientCtx.moveTo(t0.x, t0.y);
        els.ambientCtx.lineTo(t1.x, t1.y);
        els.ambientCtx.strokeStyle = p.isGreen
          ? 'rgba(52,199,89,' + trailA + ')'
          : 'rgba(255,255,255,' + trailA + ')';
        els.ambientCtx.lineWidth = p.isGreen ? 0.85 : p.highlight ? 1.1 : 0.52;
        els.ambientCtx.lineCap = 'round';
        els.ambientCtx.stroke();
      }

      var headA = p.baseAlpha * fade * (p.isGreen ? 1.2 : p.highlight ? 1.45 : 1);
      els.ambientCtx.beginPath();
      els.ambientCtx.arc(pt.x, pt.y, p.r * 3, 0, Math.PI * 2);
      els.ambientCtx.fillStyle = p.isGreen
        ? 'rgba(52,199,89,' + headA * 0.14 + ')'
        : 'rgba(255,255,255,' + headA * 0.13 + ')';
      els.ambientCtx.fill();

      els.ambientCtx.beginPath();
      els.ambientCtx.arc(pt.x, pt.y, p.r, 0, Math.PI * 2);
      els.ambientCtx.fillStyle = p.isGreen
        ? 'rgba(52,199,89,' + Math.min(0.48, headA) + ')'
        : 'rgba(255,255,255,' + Math.min(0.36, headA) + ')';
      els.ambientCtx.fill();
    }

    ambientRaf = requestAnimationFrame(ambientTick);
  }

  function startAmbientFlow() {
    if (ambientRunning || !els.ambientCtx) return;
    resizeAmbientCanvas();
    ambientRunning = true;
    lastAmbientTime = performance.now();
    ambientRaf = requestAnimationFrame(ambientTick);
  }

  function stopAmbientFlow() {
    ambientRunning = false;
    if (ambientRaf) {
      cancelAnimationFrame(ambientRaf);
      ambientRaf = null;
    }
    flowParticles = [];
    if (els.ambientCtx && els.ambientCanvas && els.composition) {
      var rect = els.composition.getBoundingClientRect();
      els.ambientCtx.clearRect(0, 0, rect.width, rect.height);
    }
  }

  function animateArc(toPct) {
    if (!els.progArc || !els.glowArc || !els.ambientArc || !els.arcDot) return;
    els.progArc.style.transition = 'none';
    els.glowArc.style.transition = 'none';
    els.ambientArc.style.transition = 'none';
    void els.progArc.offsetWidth;

    var duration = ARC_ANIM_DURATION_MS;
    var startAngle = -Math.PI / 2;
    var sweep = (toPct / 100) * 2 * Math.PI;
    var t0 = performance.now();
    els.arcDot.setAttribute('opacity', '0');

    function frame(now) {
      var u = Math.min(1, (now - t0) / duration);
      var e = easeOutCubic(u);

      var offset = ARC_C * (1 - (toPct * e) / 100);
      els.progArc.setAttribute('stroke-dashoffset', String(offset));
      els.glowArc.setAttribute('stroke-dashoffset', String(offset));
      els.ambientArc.setAttribute('stroke-dashoffset', String(offset));

      var a = startAngle + e * sweep;
      els.arcDot.setAttribute('cx', String((ARC_CX + ARC_R * Math.cos(a)).toFixed(4)));
      els.arcDot.setAttribute('cy', String((ARC_CY + ARC_R * Math.sin(a)).toFixed(4)));
      els.arcDot.setAttribute('opacity', String(u < 0.06 ? u / 0.06 : 1));

      if (u < 1) {
        requestAnimationFrame(frame);
        return;
      }

      var finalOff = ARC_C * (1 - toPct / 100);
      els.progArc.setAttribute('stroke-dashoffset', String(finalOff));
      els.glowArc.setAttribute('stroke-dashoffset', String(finalOff));
      els.ambientArc.setAttribute('stroke-dashoffset', String(finalOff));
      var af = startAngle + sweep;
      els.arcDot.setAttribute('cx', String((ARC_CX + ARC_R * Math.cos(af)).toFixed(4)));
      els.arcDot.setAttribute('cy', String((ARC_CY + ARC_R * Math.sin(af)).toFixed(4)));
      els.arcDot.setAttribute('opacity', '1');
    }
    requestAnimationFrame(frame);
  }

  function animateCount(start, end, duration, onUpdate, done) {
    var t0 = performance.now();
    function frame(now) {
      var u = Math.min(1, (now - t0) / duration);
      onUpdate(Math.round(start + (end - start) * easeOutCubic(u)));
      if (u < 1) {
        requestAnimationFrame(frame);
        return;
      }
      onUpdate(end);
      if (done) done();
    }
    requestAnimationFrame(frame);
  }

  function retireConnectorSignals() {
    connectorSignalsRetired = true;
    if (els.signalPaths) els.signalPaths.innerHTML = '';
    if (els.signalsLayerSvg) els.signalsLayerSvg.classList.add('cs-health-signals-retired');
    flowParticles = flowParticles.filter(function (p) {
      return !p.isGreen;
    });
  }

  function buildSignalPaths() {
    if (connectorSignalsRetired || !els.signalPaths || !els.composition) return;
    els.signalPaths.innerHTML = '';
    var layout = getPositions();
    var rw = layout.rect.width;
    var rh = layout.rect.height;
    var sx = 400 / rw;
    var sy = 400 / rh;
    var tcx = layout.center.x * sx;
    var tcy = layout.center.y * sy;

    layout.anchors.forEach(function (a, i) {
      if (isLightSleepMetric(i)) return;
      var ax = a.x * sx;
      var ay = a.y * sy;
      var dx = tcx - ax;
      var dy = tcy - ay;
      var mx = ax + dx * 0.38;
      var my = ay + dy * 0.38 + ((i % 3) - 1) * 6;
      var d = 'M ' + ax + ' ' + ay + ' Q ' + mx + ' ' + my + ' ' + tcx + ' ' + tcy;
      var path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', d);
      var len = path.getTotalLength ? path.getTotalLength() : 400;
      path.setAttribute('stroke-dasharray', String(len));
      path.setAttribute('stroke-dashoffset', String(len));
      path.setAttribute('data-i', String(i));
      els.signalPaths.appendChild(path);
    });
  }

  function animateSignalPath(path) {
    if (!path || !path.getTotalLength) return;
    var len = path.getTotalLength();
    var dur = 880;
    var t0 = performance.now();

    function frame(now) {
      var u = Math.min(1, (now - t0) / dur);
      var e = easeOutCubic(u);
      path.setAttribute('stroke-dashoffset', String(len * (1 - e)));
      path.style.filter = 'blur(' + 2.5 * (1 - Math.min(1, u * 5)) + 'px)';
      if (u < 0.14) path.style.opacity = String(Math.min(1, u / 0.14) * 0.9);
      else if (u > 0.65) path.style.opacity = String(0.9 * (1 - (u - 0.65) / 0.35));
      else path.style.opacity = '0.9';
      if (u < 1) {
        requestAnimationFrame(frame);
        return;
      }
      path.style.opacity = '0';
      path.setAttribute('stroke-dashoffset', String(len));
    }
    requestAnimationFrame(frame);
  }

  function runParticle(i, layout) {
    if (!els.accentParticlesEl) return;
    var anchor = layout.anchors[i];
    var dx = anchor.x - layout.center.x;
    var dy = anchor.y - layout.center.y;
    var size = 4 + Math.random() * 2;
    var p = document.createElement('div');
    p.className = 'cs-health-particle';
    p.style.width = size + 'px';
    p.style.height = size + 'px';
    p.style.marginLeft = -size / 2 + 'px';
    p.style.marginTop = -size / 2 + 'px';
    p.style.boxShadow = '0 0 ' + size * 2 + 'px rgba(52,199,89,0.7)';
    p.style.setProperty('--sx', dx + 'px');
    p.style.setProperty('--sy', dy + 'px');
    els.accentParticlesEl.appendChild(p);
    requestAnimationFrame(function () {
      p.classList.add('cs-health-particle--run');
    });
    setTimeout(function () {
      if (p.parentNode) p.remove();
    }, 1060);
  }

  function triggerSignal(i) {
    buildSignalPaths();
    var paths = els.signalPaths.querySelectorAll('path');
    var cards = els.orbit.querySelectorAll('.cs-health-metric-card');
    var layout = getPositions();
    if (paths[i]) animateSignalPath(paths[i]);
    if (cards[i]) cards[i].classList.add('cs-health-signal-sent');
    if (!isLightSleepMetric(i)) runParticle(i, layout);
  }

  function resetDomState() {
    if (els.composition) els.composition.classList.remove('cs-health-graph-composition--running');
    connectorSignalsRetired = false;
    hiddenFlowSvg = null;
    ambientPathRefs = [];
    flowParticles = [];
    if (els.signalPaths) els.signalPaths.innerHTML = '';
    if (els.signalsLayerSvg) els.signalsLayerSvg.classList.remove('cs-health-signals-retired');
    if (els.accentParticlesEl) els.accentParticlesEl.innerHTML = '';
    if (els.scoreEyebrow) {
      els.scoreEyebrow.classList.remove('cs-health-score-eyebrow--on');
    }
    if (els.scoreBadge) els.scoreBadge.classList.remove('cs-health-score-badge--on');
    if (els.scoreWrap) {
      els.scoreWrap.classList.remove('cs-health-score-wrap--pulse-once', 'cs-health-score-wrap--idle-breathe');
    }
    if (els.scoreNum) els.scoreNum.textContent = '0';
    initArc(els.progArc);
    initArc(els.glowArc, 0.36);
    initArc(els.ambientArc, 0.14);
    buildMetricCards();
    ensureHiddenFlowSvg();
  }

  function handleCompositionResize() {
    syncOrbitRadius();
    if (!connectorSignalsRetired) buildSignalPaths();
    resizeAmbientCanvas();
  }

  function reducedMotionFinish(gen) {
    if (gen !== seqGen) return;
    retireConnectorSignals();
    METRICS.forEach(function (_, i) {
      var cards = els.orbit.querySelectorAll('.cs-health-metric-card');
      if (cards[i]) {
        cards[i].classList.add('cs-health-metric-card--on', 'cs-health-signal-sent');
        cards[i].style.setProperty('--pull', '1');
      }
    });
    if (els.scoreEyebrow) els.scoreEyebrow.classList.add('cs-health-score-eyebrow--on');
    if (els.scoreNum) els.scoreNum.textContent = String(TARGET);
    var finalOff = ARC_C * (1 - TARGET / 100);
    ['progArc', 'glowArc', 'ambientArc'].forEach(function (k) {
      if (els[k]) els[k].setAttribute('stroke-dashoffset', String(finalOff));
    });
    if (els.arcDot) {
      var sweep = (TARGET / 100) * 2 * Math.PI;
      var a = -Math.PI / 2 + sweep;
      els.arcDot.setAttribute('cx', String((ARC_CX + ARC_R * Math.cos(a)).toFixed(4)));
      els.arcDot.setAttribute('cy', String((ARC_CY + ARC_R * Math.sin(a)).toFixed(4)));
      els.arcDot.setAttribute('opacity', '1');
    }
    if (els.scoreBadge) els.scoreBadge.classList.add('cs-health-score-badge--on');
    if (els.scoreWrap) els.scoreWrap.classList.add('cs-health-score-wrap--idle-breathe');
    fireComplete(gen);
  }

  function fireComplete(gen) {
    if (gen !== seqGen) return;
    stopAmbientFlow();
    if (typeof onCompleteCb === 'function') {
      var fn = onCompleteCb;
      onCompleteCb = null;
      fn();
    }
  }

  function startSequence(gen) {
    if (els.composition) els.composition.classList.add('cs-health-graph-composition--running');

    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reducedMotionFinish(gen);
        return;
      }
    } catch (e) {}

    setTimeout(function () {
      if (gen !== seqGen) return;
      if (els.scoreEyebrow) els.scoreEyebrow.classList.add('cs-health-score-eyebrow--on');
    }, 380);

    var stagger = 130;
    var cardDelay = 420;

    METRICS.forEach(function (_, i) {
      setTimeout(function () {
        if (gen !== seqGen) return;
        var cards = els.orbit.querySelectorAll('.cs-health-metric-card');
        if (cards[i]) {
          cards[i].classList.add('cs-health-metric-card--on');
          animateMetricPull(cards[i]);
        }
        setTimeout(function () {
          if (gen !== seqGen) return;
          triggerSignal(i);
        }, 165);
      }, cardDelay + i * stagger);
    });

    var lastCardAt = cardDelay + (METRICS.length - 1) * stagger;
    var lastSignalEnd = lastCardAt + 165 + 920;
    var scoreStart = lastSignalEnd + 220;

    setTimeout(function () {
      if (gen !== seqGen) return;
      retireConnectorSignals();
      animateCount(
        0,
        TARGET,
        ARC_ANIM_DURATION_MS,
        function (n) {
          if (els.scoreNum) els.scoreNum.textContent = String(n);
        },
        function () {
          if (gen !== seqGen) return;
          if (els.scoreBadge) els.scoreBadge.classList.add('cs-health-score-badge--on');
          if (els.scoreWrap) els.scoreWrap.classList.add('cs-health-score-wrap--pulse-once');
          setTimeout(function () {
            if (gen !== seqGen) return;
            if (els.scoreWrap) {
              els.scoreWrap.classList.remove('cs-health-score-wrap--pulse-once');
              els.scoreWrap.classList.add('cs-health-score-wrap--idle-breathe');
            }
          }, 1000);
          fireComplete(gen);
        }
      );
      animateArc(TARGET);
    }, scoreStart);
  }

  function observeComposition() {
    if (!els.composition) return;
    if (typeof ResizeObserver !== 'undefined') {
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = new ResizeObserver(function () {
        handleCompositionResize();
      });
      resizeObserver.observe(els.composition);
    } else {
      window.addEventListener(
        'resize',
        function onWinResize() {
          clearTimeout(resizeFallbackTimer);
          resizeFallbackTimer = setTimeout(handleCompositionResize, 120);
        },
        { passive: true }
      );
    }
  }

  window.csHealthGraphStep5 = {
    start: function (stepEl, options) {
      options = options || {};
      stop();
      stepRoot = stepEl;
      onCompleteCb = options.onComplete || null;
      seqGen++;
      var gen = seqGen;

      bindElements();
      if (!els.composition) return;

      registerCssProps();
      resetDomState();

      syncOrbitRadius();
      buildSignalPaths();
      ensureHiddenFlowSvg();
      resizeAmbientCanvas();
      startAmbientFlow();
      observeComposition();

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (gen !== seqGen) return;
          syncOrbitRadius();
          buildSignalPaths();
          resizeAmbientCanvas();
          startSequence(gen);
        });
      });
    },

    stop: function () {
      seqGen++;
      onCompleteCb = null;
      stopAmbientFlow();
      var compEl = els.composition;
      if (resizeObserver && compEl) {
        try {
          resizeObserver.unobserve(compEl);
        } catch (e) {}
      }
      resizeObserver = null;
      if (stepRoot) {
        var comp = stepRoot.querySelector('#cs-hs-composition');
        if (comp) {
          comp.classList.remove('cs-health-graph-composition--running');
          var hf = comp.querySelector('svg[data-cs-hs-flow-paths]');
          if (hf) hf.remove();
        }
      }
      stepRoot = null;
      els = {};
      hiddenFlowSvg = null;
      connectorSignalsRetired = false;
    }
  };
})();
